<template>
  <div v-loading="loading">
    <el-row :gutter="24">
      <el-col :sm="24" :md="18" class="box">
        <h2>id: {{ form.short_id }}</h2>
        <div>
          <h4>imię i nazwisko: {{ form.name }}</h4>
        </div>
        <div>
          <h4>dzielnica Warszawy: {{ getDistrictLabel(form) }}</h4>
        </div>
        <div>
          <h4>email: {{ form.email }}</h4>
        </div>
        <div>
          <h4>plik svg: <a :href="form.face_file.file" target="_blank">OTWÓRZ W NOWEJ KARCIE</a></h4>
        </div>
        <div>
          <h4>zdjęcie podglądowe:</h4><br>
          <a :href="form.face_file.thumbnail" target="_blank">
            <img style="max-height: 400px;" class="thumbnail" :src="form.face_file.thumbnail" alt="" />
          </a>

        </div>

      </el-col>
      <el-col :sm="24" :md="6">
        <div class="box">
          <router-link
            :to="{ ...redirectRoute, query: this.$route.query }"
            v-if="!inModal && redirectRoute"
          >
            <el-button class="fluid form__button">
              <i class="fa fa-arrow-left" />
              Wróć do listy
            </el-button>
          </router-link>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { CompetitionApplication } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import FiltersMixin from '@/views/CompetitionApplication/FiltersMixin'

export default {
  extends: FormMixin,
  mixins: [FiltersMixin],
  data() {
    return {
      form: {},
      redirectRoute: { name: 'CompetitionApplication List' }
    }
  },
  computed: {
    service() {
      return CompetitionApplication
    }
  },
  beforeMount() {
    this.fetchData()
    this.prepareFormCopyToPreventChangesLost()
    this.fetchOptions()
  },
  methods: {
    fetchOptions() {
      this.setDistrictOptions([])
    },
  }
}
</script>
